export const PageHero = ({ eyebrow, title, intro, image }) => (
  <section className="relative pt-40 pb-24 md:pb-32 overflow-hidden">
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink/95 via-ink/85 to-ink/55" />
      <div className="absolute inset-0 bg-ink/25" />
    </div>
    <div className="container-px relative z-10">
      <div className="max-w-3xl animate-fade-up">
        <p className="overline !text-gold">{eyebrow}</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.05] tracking-tight mt-5">
          {title}
        </h1>
        {intro && (
          <p className="text-ivory/75 text-lg sm:text-xl font-light mt-6 leading-relaxed">
            {intro}
          </p>
        )}
      </div>
    </div>
  </section>
);
